import { ReactNode } from "react";
import { View } from "./View";

export interface IBulletPointProps {
  icon: ReactNode;
  title: string;
  description: string;
  className?: string;
}

export const BulletPoint = (props: IBulletPointProps) => {
  return <View {...props} />;
};
